import { render, staticRenderFns } from "./PhasesDetailsComponent.vue?vue&type=template&id=48ae897c&"
import script from "./PhasesDetailsComponent.vue?vue&type=script&lang=js&"
export * from "./PhasesDetailsComponent.vue?vue&type=script&lang=js&"
import style0 from "./PhasesDetailsComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports